"use client";

import { useEffect, useRef, useState } from "react";
import { stats } from "../data";

const StatsSection = () => {
  const [isStatsVisible, setIsStatsVisible] = useState(false);
  const statsRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };

    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsStatsVisible(true);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    const currentRef = statsRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={statsRef} className="mb-24">
      <div className="text-center mb-14">
        <h2 className="text-3xl md:text-5xl font-bold mb-4 text-gray-200">
          Powering the Pulse of Productivity
        </h2>
        <p className="text-gray-300 max-w-2xl mx-auto">
          Empowering Meetings Worldwide
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto">
        {stats.map((stat, index) => (
          <div 
            key={index}
            className={`
              text-center transition-opacity duration-250 ease-out
              ${isStatsVisible ? 'opacity-100' : 'opacity-0'}
            `}
          >
            <div className="text-6xl md:text-7xl lg:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#38bdf8] to-[#818cf8] mb-3">
              {stat.value}
            </div>
            <div className="text-gray-300 text-base md:text-lg uppercase tracking-wider font-medium">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsSection; 